// extracted by mini-css-extract-plugin
export default {"priceBadge":"priceBadge-module__priceBadge__bjLZu"};